import { logger } from '@src/utils/misc/logger';
import apptracker from '@src/utils/sensor/apptracker';
import { NEXA_DASHBOARD_LINK_CLICK } from '@src/utils/sensor/track';
import { HandlerOptions } from './types';

/**
 * Handles fetch_viewer_sessions_csv tool - opens viewer module dashboard in a new tab
 */
export const handleViewerModule = (options: HandlerOptions): void => {
  try {
    const { args, baseUrl } = options;
    const { viewer_id } = args || {};

    if (!viewer_id) {
      logger.error('Missing required viewer_id for viewer module', { args });
      return;
    }

    const url = `${baseUrl}/dashboard/viewer-module/${viewer_id}`;

    if (url) {
      window.open(url, '_blank');
      apptracker(NEXA_DASHBOARD_LINK_CLICK, { type: 'viewer_module', url });
      logger.log('Opened viewer module in new tab:', url);
    }
  } catch (error) {
    logger.error('Error handling viewer module:', error);
  }
};
